/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { CardTextButtons } from '@gerdau/hefesto/CardTextButtons';
import { Title } from '@gerdau/hefesto/Title';
import { Container } from './styles';
import { EOrderSettingsRoutes } from '../LongSteel/OrderSettingsMvp/orderSettings.routes';
import { ERoutes } from '../../../routes';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { EPurchaseRoutes } from '../purchase.routes';
import {
  cleanSearchItemErrors,
  removeSearchedItem
} from '../../../store/ducks/long-steel-order-item-search/actions';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import LoadingModal from '../../../components/LoadingModal';
import { CustomersState } from '../../../store/ducks/customers/types';

const PurchaseHome: React.FC = () => {
  const [allCustomerTypeCG, setAllCustomerTypeCG] = useState(false);

  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const hasUserFabricationAccess = useSelector(
    (appState: ApplicationState) =>
      appState.user.userPermissions.hasFabricationAccess
  );

  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  ) as CustomersState;

  const userState = useSelector((appState: ApplicationState) => appState.user);

  const orderItemSearch = useSelector(
    (state: ApplicationState) => state.longSteelOrderItemSearch
  );
  const cleanSearchedItems = () => {
    dispatch(removeSearchedItem([]));
  };

  const cleanErrors = () => {
    dispatch(cleanSearchItemErrors());
  };

  useEffect(() => {
    const fetchUserAndCustomers = async () => {
      if (!customersState.loading) {
        const verifyRoleCustomer = userState.roles.ordersInputCustomers.every(
          (roleCustomer) =>
            customersState.customers.some((customer) => {
              return (
                customer.customerId === roleCustomer &&
                customer.customerType === 'CG'
              );
            })
        );

        setAllCustomerTypeCG(verifyRoleCustomer);
      }
    };

    fetchUserAndCustomers();
  }, [customersState.loading]);

  useEffect(() => {
    if (orderItemSearch?.searchedItems?.length > 0) {
      cleanSearchedItems();
    }
  });

  useEffect(() => {
    if (
      orderItemSearch?.searchingItemsError ||
      orderItemSearch?.searchingItemsSpreadsheetError ||
      orderItemSearch?.searchingItemsLastOrderError
    ) {
      cleanErrors();
    }
  });

  const redirectTo = (
    buttonLabel: string,
    midleOrderSettingsRoute: EOrderSettingsRoutes | EPurchaseRoutes,
    orderSettingsRoute?: EOrderSettingsRoutes | EPurchaseRoutes
  ) => {
    const isFabrication =
      midleOrderSettingsRoute === EPurchaseRoutes.FABRICATION;
    let itemDescription = '';
    isFabrication
      ? (itemDescription = 'Corte_e_dobra')
      : (itemDescription = 'acos_longos');
    dispatch(
      sendTagging({
        screenName: location.pathname,
        event: 'click',
        itemName: `button:${buttonLabel.replaceAll(' ', '_')}`,
        itemDescription: itemDescription
      })
    );
    const route = isFabrication
      ? `${ERoutes.PURCHASE}/${midleOrderSettingsRoute}`
      : `${ERoutes.PURCHASE}/${
          EOrderSettingsRoutes.LONG_STEEL
        }/${midleOrderSettingsRoute}/${orderSettingsRoute ?? ''}`;
    history.push(route);
  };

  return (
    <Container>
      <header>
        <Title level={1}>Comprar aços</Title>
        <span>Selecione como você deseja comprar produtos ou serviços.</span>
      </header>

      {!customersState.loading && (
        <div className="cards">
          <div className="subtitle-cards">
            <Title level={2}>Aços longos</Title>
          </div>
          <div className="cards-container">
            <div className="card">
              <CardTextButtons
                title={'Comprar por vitrine'}
                description={
                  'Explore o portifólio de produtos disponíveis para seu negócio através da vitrine.'
                }
                buttonProps={{
                  label: 'Comprar por vitrine',
                  onClick: () => {
                    redirectTo(
                      'Comprar por vitrine',
                      EPurchaseRoutes.COMMERCE,
                      EOrderSettingsRoutes.CATALOG
                    );
                  }
                }}
              />
            </div>
            <div className="card">
              <CardTextButtons
                title={'Comprar selecionando itens'}
                description={
                  'Selecione e compre seus produtos pelos códigos de SKU ou descrição do material.'
                }
                buttonProps={{
                  label: 'Comprar selecionando itens',
                  onClick: () => {
                    redirectTo(
                      'Comprar selecionando itens',
                      EPurchaseRoutes.COMMERCE,
                      EOrderSettingsRoutes.SEARCH_ITEMS
                    );
                  }
                }}
              />
            </div>
            {!allCustomerTypeCG && (
              <div className="card">
                <CardTextButtons
                  title={'Comprar por planilha'}
                  description={
                    'Preencha e envie uma planilha com os dados dos produtos desejados para montar o seu carrinho.'
                  }
                  buttonProps={{
                    label: 'Comprar por planilha',
                    onClick: () => {
                      redirectTo(
                        'Comprar por planilha',
                        EPurchaseRoutes.COMMERCE,
                        EOrderSettingsRoutes.SPREADSHEET_UPLOAD
                      );
                    }
                  }}
                />
              </div>
            )}
            <div className="card">
              <CardTextButtons
                title={'Comprar por histórico'}
                description={'Abra seu histórico de pedidos para refazê-los.'}
                buttonProps={{
                  label: 'Comprar por histórico',
                  onClick: () => {
                    redirectTo(
                      'Comprar por histórico',
                      EPurchaseRoutes.COMMERCE,
                      EOrderSettingsRoutes.REPEAT_ORDER
                    );
                  }
                }}
              />
            </div>
          </div>
          {hasUserFabricationAccess && (
            <>
              <div className="subtitle-cards">
                <Title level={2}>Corte e dobra</Title>
              </div>
              <div className="cards-container">
                <div className="card">
                  <CardTextButtons
                    title={'Solicitar corte e dobra'}
                    description={
                      'Solicite aços cortados e dobrados de acordo com a necessidade dos seus projetos.'
                    }
                    buttonProps={{
                      label: 'Solicitar corte e dobra',
                      onClick: () => {
                        redirectTo(
                          'Solicitar corte e dobra',
                          EPurchaseRoutes.FABRICATION
                        );
                      }
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      )}
      <LoadingModal
        enabled={customersState.loading}
        title="Aguarde alguns instantes"
        message="Carregando os dados..."
      />
    </Container>
  );
};
export default PurchaseHome;
